import { FaChartPie } from "react-icons/fa6";
import { FiClock } from "react-icons/fi";
import { HiOutlineUserCircle, HiUsers } from "react-icons/hi2";
import { IoMdHelpCircleOutline, IoMdLock } from "react-icons/io";
import { LuHistory, LuLogOut } from "react-icons/lu";
import { RiDeleteBinLine, RiMessage2Line } from "react-icons/ri";
import { ProfileViewtalwind } from "../../PageComponent/ProfilePage/ProfilePageTalwind";
import { logoutOnJwtExpire } from "../../utils/helperFunctions";
import { IoSettingsSharp } from "react-icons/io5";

export const settingsLinks = [
    {
        linkTo: '/profile/details',
        icon: (
            <HiOutlineUserCircle className={ProfileViewtalwind.IconStyle} />
        ),
        mobIcon: <RiMessage2Line className={ProfileViewtalwind.MobIconStyle} />,
        name: 'Personal Details',
    },
    {
        linkTo: '/profile/settings',
        icon: (
            <IoSettingsSharp className={ProfileViewtalwind.IconStyle} />
        ),
        mobIcon: <IoSettingsSharp className={ProfileViewtalwind.MobIconStyle} />,
        name: 'Security Settings',
    },
    {
        linkTo: '/profile/appointment',
        icon: <LuHistory className={ProfileViewtalwind.IconStyle} />,
        mobIcon: <FiClock className={ProfileViewtalwind.MobIconStyle} />,
        name: 'Appointment History',
    },
    {
        linkTo: '/profile/changepassword',
        icon: <IoMdLock className={ProfileViewtalwind.IconStyle} />,
        mobIcon: '',
        name: 'Change password',
    },
    {
        linkTo: '/profile/aboutus',
        icon: <HiUsers className={ProfileViewtalwind.IconStyle} />,
        mobIcon: '',
        name: 'About Us',
    },
    {
        linkTo: '/profile/privacy',
        icon: <FaChartPie className={ProfileViewtalwind.IconStyle} />,
        mobIcon: '',
        name: 'Privacy and Safety',
    },
    {
        linkTo: '/profile/help',
        icon: (
            <IoMdHelpCircleOutline className={ProfileViewtalwind.IconStyle} />
        ),
        mobIcon: '',
        name: 'Help Center',
    },
    {
        linkTo: '/profile/deleteaccount',
        icon: <RiDeleteBinLine className={ProfileViewtalwind.IconStyle} />,
        mobIcon: '',
        name: 'Delete Account',
    },
    {
        linkTo: '/profile/logout',
        icon: <LuLogOut className={ProfileViewtalwind.IconStyle} />,
        mobIcon: '',
        name: 'Logout',
        onclick: logoutOnJwtExpire,
    },
];